"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function x(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5897 4.71712H11.9997V9.12862L10.5897 7.65637V4.71712Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.51088 6.20436H8.22263C9.48038 7.52061 10.7434 8.83461 12.0011 10.1539C12.7294 9.39711 13.4554 8.63511 14.1806 7.87611C14.7169 7.32036 15.2509 6.76161 15.7856 6.20361H19.4884C17.7604 7.95111 16.0346 9.70011 14.3059 11.4461C14.1244 11.6284 13.9421 11.8121 13.7644 11.9966C13.8079 12.0431 13.8544 12.0889 13.8934 12.1384L18.9716 17.2729L19.4899 17.7949H16.6174C16.5431 17.7949 16.4689 17.7994 16.3961 17.7896C16.1914 17.7836 15.9859 17.7926 15.7811 17.7851C15.4099 17.4019 15.0431 17.0134 14.6719 16.6286C13.9421 15.8696 13.2154 15.1061 12.4856 14.3456C12.3236 14.1776 12.1654 14.0051 11.9996 13.8416C11.6471 14.2166 11.2856 14.5864 10.9309 14.9614L8.92313 17.0569C8.68913 17.3006 8.45813 17.5459 8.22263 17.7851C8.02013 17.7911 7.81613 17.7851 7.61213 17.7881C7.49588 17.8024 7.37813 17.7926 7.26188 17.7956H4.51013L9.96113 12.2831C10.0549 12.1886 10.1479 12.0934 10.2386 11.9966L4.51013 6.20436H4.51088Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.0026 14.8579C12.4721 15.3551 12.9476 15.8471 13.4186 16.3429C13.4216 17.3231 13.4186 18.3019 13.4186 19.2829H12.0011C12.0011 17.8076 12.0011 16.3331 12.0041 14.8579H12.0026Z", fill: color }));
}
exports["default"] = x;
//# sourceMappingURL=x.js.map